import { useEffect, useState } from "react"
import { MdClose } from "react-icons/md"
import { FiPlus } from "react-icons/fi"
import { useSelector } from "react-redux"

export default function RequirementsField({
  name,
  label,
  register,
  setValue,
  errors,
  getValues,
}) {
  const { editCourse, course } = useSelector((state) => state.course)
  const [list, setList] = useState([])

  useEffect(() => {
    if (editCourse) setList(course?.instructions ?? [])
    register(name, { required: true, validate: (value) => value.length > 0 })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setValue(name, list)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list])

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault()
      const val = e.target.value.trim()
      if (val && !list.includes(val)) {
        setList([...list, val])
        e.target.value = ""
      }
    }
  }

  const handleAdd = (inputEl) => {
    const val = inputEl?.value?.trim()
    if (val && !list.includes(val)) {
      setList([...list, val])
      inputEl.value = ""
      inputEl.focus()
    }
  }

  const handleRemove = (index) =>
    setList(list.filter((_, i) => i !== index))

  return (
    <div className="flex flex-col gap-1.5">
      <label className="text-sm font-medium text-richblack-5" htmlFor={name}>
        {label} <sup className="text-pink-200">*</sup>
      </label>

      {/* Added items */}
      {list.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {list.map((item, index) => (
            <div
              key={index}
              className="flex items-center gap-1.5 rounded-full bg-yellow-400/20 border border-yellow-400/30 px-3 py-1 text-sm text-yellow-50"
            >
              <span>{item}</span>
              <button
                type="button"
                onClick={() => handleRemove(index)}
                className="flex-shrink-0 rounded-full text-yellow-50/70 hover:text-yellow-50 transition-colors"
              >
                <MdClose size={14} />
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Input row */}
      <div className="relative">
        <input
          id={name}
          type="text"
          placeholder="Type a requirement and press Enter"
          onKeyDown={handleKeyDown}
          className="form-style w-full !pr-10"
        />
        <button
          type="button"
          title="Add requirement"
          onClick={(e) =>
            handleAdd(e.currentTarget.closest(".relative").querySelector("input"))
          }
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-richblack-400 transition-colors hover:text-yellow-50"
        >
          <FiPlus size={18} />
        </button>
      </div>

      {errors[name] && (
        <p className="flex items-center gap-1 text-xs text-pink-200">
          <span>⚠</span> At least one requirement is needed
        </p>
      )}
    </div>
  )
}
